import { formatBooleanValue } from "../../util";
import IndexTypeCategory from "../model/IndexTypeCategory";

const IndexTypeCategoryMapper = (item: any) => {
  let indexTypeCategory = IndexTypeCategory(item);
  indexTypeCategory.valid = formatBooleanValue(item.valid);
  return indexTypeCategory;
};

export default IndexTypeCategoryMapper;
